import {TypetValideringsresultatModell} from "../tjenester/ressurser/ng2HttpKlientTilleggstyper";

/** Returnerer sann dersom angitt valideringsresultat inneholder angitt feilkode */
export function inneholderFeil<T>(valideringsresultat: TypetValideringsresultatModell<T>, feilkode: T): boolean {
    if (!valideringsresultat.harFeil) return false;
    return valideringsresultat.feil.some(feil => feil.feilkode === feilkode);
}

/** Returnerer {@link TypetValideringsresultatModell} med harFeil:false */
export function  okTypetValideringsresultatModell<T>():TypetValideringsresultatModell<T>{
    return {harFeil: false, feil: []};
}
